import 'react-datepicker/dist/react-datepicker.css';
import '@/styles/datepicker.css';

import { CalendarIcon } from '@chakra-ui/icons';
import {
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react';
import ja from 'date-fns/locale/ja';
import React, { forwardRef } from 'react';
import ReactDatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';
registerLocale('ja', ja);

interface Props extends ReactDatePickerProps {
  selectedDate?: Date;
  onChange: (date: Date) => void;
}

const CustomInput = forwardRef<HTMLInputElement, InputProps>(
  function CustomInputButton({ value, onClick, ...rest }, ref) {
    return (
      // @ts-ignore TS2590
      <InputGroup>
        <Input
          // @ts-ignore TS2590
          onClick={onClick}
          bg="white"
          width="100%"
          {...rest}
          ref={ref}
          value={value}
        />
        <InputRightElement pointerEvents="none">
          <CalendarIcon />
        </InputRightElement>
      </InputGroup>
    );
  }
);

export const CmDatePicker: React.FC<Props> = ({
  selectedDate,
  onChange,
  timeIntervals = 5,
  dateFormat = 'yyyy/MM/dd',
  ...rest
}) => {
  return (
    <ReactDatePicker
      selected={selectedDate}
      onChange={onChange}
      locale="ja"
      {...{ ...rest, dateFormat, timeIntervals }}
      customInput={<CustomInput />}
    />
  );
};
